import { Toast } from '@arco-design/mobile-react';

export const mobileMessage = {
  info: (content: string) => Toast.info({ content }),
  success: (content: string) => Toast.success({ content }),
  warning: (content: string) => Toast.warn({ content })
};
